// Labels the existing support widget without changing its configuration or state.
function labelSupportWidget() {
  document.querySelectorAll('button.woot-widget-bubble').forEach(button => {
    const label = button.classList.contains('woot--close') ? 'Cerrar chat de Sendi' : 'Chatea con nosotros: abrir chat de Sendi';
    button.setAttribute('aria-label', label);
    button.title = label;
  });
  document.querySelectorAll('.woot-widget-holder iframe').forEach(frame => { frame.title = 'Chat de soporte de Sendi'; });
}
labelSupportWidget();
new MutationObserver(labelSupportWidget).observe(document.body, {childList: true, subtree: true});
